export const LeaksInternalStatusOptions = [
  { name: 'All', id: 'All' },
  { name: 'Unknown', id: 'UNKNOWN' },
  { name: 'Leak', id: 'LEAK' },
];
